import { ImageOrientation } from '@space-core/components/customImage/enum'

import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'

import { focusVisible } from '@space-core/styles'
import styled from 'styled-components'

import BundleCardMobileDefault from '../mobileDefault'
import type { BundleCardProps } from '../types'

import '@hotmart/cosmos/dist/styles/utilities/text/variations/green.css'

const BundleButton = styled.button<{
  isCarousel?: boolean
  imageOrientation?: ImageOrientation
  isMobile?: boolean
}>`
  background: 0;
  ${focusVisible}
  ${({ isCarousel, imageOrientation, isMobile }) =>
    isCarousel
      ? `
    flex: none;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
    width: ${
      imageOrientation === ImageOrientation.HORIZONTAL
        ? isMobile
          ? '85%'
          : '30.5%'
        : isMobile
        ? '45%'
        : '35%'
    };
    margin-right: var(--spacer-2);

    :first-child {
      margin-left: var(--spacer-2);
    }
  `
      : `
  width: ${imageOrientation !== ImageOrientation.HORIZONTAL ? '29.5%' : 'auto'};
`}
`

const BundleCardMobile = ({
  bundle,
  handleClick,
  isCarousel,
  themeMode,
  containerOrientation,
  imageOrientation
}: BundleCardProps) => {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.sm})`)

  return (
    <BundleButton
      data-test='bundle-btn'
      onClick={handleClick}
      isCarousel={isCarousel}
      isMobile={isMobile}
      imageOrientation={imageOrientation}
      className='_border-0 _p-0'
      aria-label='button'>
      <BundleCardMobileDefault
        bundle={bundle}
        themeMode={themeMode}
        containerOrientation={containerOrientation}
        imageOrientation={imageOrientation}
      />
    </BundleButton>
  )
}

export default BundleCardMobile
